/**
 * AUTO-GENERATED FILE — do not edit.
 *
 * Generated by `apps/web/scripts/generate-profile-bundle.mjs` from the JSON
 * files in `document-profiles/`. Those JSON files are the single source of
 * truth: the frontend only mirrors them here because a bundler cannot import
 * files from outside its root.
 *
 * Documents: us-visa-ds160.json, ru-zagran-gosuslugi.json
 */

export const DOCUMENT_PROFILE_FILES: readonly string[] = [
  "us-visa-ds160.json",
  "ru-zagran-gosuslugi.json"
];

export const DOCUMENT_PROFILES: unknown[] = [
  {
    "id": "us-visa-ds160",
    "schemaVersion": "1.0",
    "name": "Виза США / DS-160",
    "shortName": "US Visa / DS-160",
    "country": "US",
    "authority": "U.S. Department of State (Bureau of Consular Affairs)",
    "sourceUrl": "https://travel.state.gov/content/travel/en/us-visas/visa-information-resources/photos/photo-composition-template.html",
    "sourceUrls": [
      "https://travel.state.gov/content/travel/en/us-visas/visa-information-resources/photos/photo-composition-template.html",
      "https://adoptions.state.gov/content/travel/en/us-visas/inmigracion/plantilla-de-composicion-de-foto.html",
      "https://travel.state.gov/content/travel/en/us-visas/visa-information-resources/photos/digital-image-requirements.html",
      "https://staging.ustraveldocs.com/ve/ve-niv-photoinfo.asp"
    ],
    "sourceCheckedAt": "2026-09-15",
    "provenance": {
      "sourceName": "U.S. Department of State — Photo Composition Template (U.S. Visas)",
      "sourceUrl": "https://travel.state.gov/content/travel/en/us-visas/visa-information-resources/photos/photo-composition-template.html",
      "checkedAt": "2026-09-15",
      "requirementsVersion": "Photo Composition Template / Digital Image Requirements, редакция на 2026-09-15",
      "secondarySources": [
        {
          "name": "U.S. Department of State — Photo Composition Template (официальное зеркало adoptions.state.gov)",
          "url": "https://adoptions.state.gov/content/travel/en/us-visas/inmigracion/plantilla-de-composicion-de-foto.html"
        },
        {
          "name": "U.S. Department of State — Digital Image Requirements",
          "url": "https://travel.state.gov/content/travel/en/us-visas/visa-information-resources/photos/digital-image-requirements.html"
        },
        {
          "name": "ustraveldocs (CGI Federal, официальная система записи) — Photos and Fingerprints",
          "url": "https://staging.ustraveldocs.com/ve/ve-niv-photoinfo.asp"
        }
      ],
      "status": "verified",
      "note": "Диапазоны «голова 50–69 %» и «глаза 56–69 %» подтверждены официальной Photo Composition Template Государственного департамента (проверено 2026-09-15 через официальное зеркало adoptions.state.gov: страницы travel.state.gov отдают 403 для автоматических запросов с нашего IP). Консульская страница ustraveldocs приводит более широкие границы (голова 50–70 %, глаза 55–70 %); в профиле используются более строгие официальные значения из composition template."
    },
    "verificationNote": "Внутренних сужений официальных границ в профиле нет: единственная добавленная величина — tolerance измерения (0,01 высоты кадра), которая расширяет зону «не уверены», а не зону отказа. Внутренний минимум размера файла помечен как policy и даёт только предупреждение: официального минимума не существует.",
    "disclaimer": "Проверка выполняется по опубликованным требованиям выбранного документа. Автоматическая проверка не гарантирует принятие фотографии государственным органом или визовым центром. Итоговое решение принимает консульский отдел.",
    "aliases": [
      "us-visa",
      "usa-visa",
      "visa-usa",
      "ds-160",
      "ds160",
      "viza-ssha",
      "viza-v-ssha"
    ],
    "tags": [
      "visa",
      "us",
      "square",
      "50x50mm",
      "verified"
    ],
    "image": {
      "minWidth": 600,
      "maxWidth": 1200,
      "minHeight": 600,
      "maxHeight": 1200,
      "aspectRatio": {
        "min": 0.99,
        "max": 1.01
      },
      "requiredAspectRatio": {
        "width": 1,
        "height": 1
      },
      "aspectRatioNote": "Официально: квадратное изображение, высота равна ширине (2×2 дюйма, 50×50 мм).",
      "maxFileSize": 245760,
      "warnBelowBytes": 10240,
      "formats": [
        "jpeg"
      ],
      "digital": {
        "minWidth": 600,
        "minHeight": 600,
        "maxWidth": 1200,
        "maxHeight": 1200,
        "source": "Официальные границы: от 600×600 до 1200×1200 пикселей."
      },
      "colorSpace": "sRGB",
      "dpi": 300,
      "notes": [
        "Квадратное изображение: от 600×600 до 1200×1200 пикселей (официально).",
        "Печатный размер 2×2 дюйма (50×50 мм).",
        "Загрузка в форму DS-160: JPEG до 240 КБ (245 760 байт).",
        "Официального минимума размера файла нет; 10 КБ — внутренний порог качества (policy), даёт только предупреждение.",
        "Фотография должна быть сделана не позднее шести месяцев до подачи заявления."
      ],
      "nominalPhotoSize": {
        "widthMm": 50,
        "heightMm": 50
      }
    },
    "rules": {
      "file_format": {
        "enabled": true,
        "severity": "error",
        "official": {
          "statement": "The digital image must be in JPEG format."
        },
        "params": {
          "formats": [
            "jpeg"
          ]
        }
      },
      "file_size": {
        "enabled": true,
        "severity": "error",
        "official": {
          "max": 245760,
          "unit": "bytes",
          "statement": "The DS-160 upload accepts a JPEG file of at most 240 KB (245 760 bytes)."
        },
        "measurement": {
          "tolerance": 0
        },
        "policy": {
          "min": 10240,
          "onViolation": "warning",
          "reason": "Внутренний порог качества: слишком маленький файл обычно означает сильную компрессию. Официального минимума размера файла нет, поэтому это не отказ, а рекомендация."
        },
        "params": {
          "maxBytes": 245760,
          "warnBelowBytes": 10240
        }
      },
      "image_size": {
        "enabled": true,
        "severity": "error",
        "official": {
          "min": 600,
          "max": 1200,
          "unit": "px",
          "statement": "Square image: minimum 600×600 px, maximum 1200×1200 px."
        },
        "measurement": {
          "tolerance": 0
        },
        "params": {
          "minWidth": 600,
          "maxWidth": 1200,
          "minHeight": 600,
          "maxHeight": 1200
        }
      },
      "aspect_ratio": {
        "enabled": true,
        "severity": "error",
        "official": {
          "min": 0.99,
          "max": 1.01,
          "unit": "ratio",
          "statement": "The photo must be square: the height must be equal to the width."
        },
        "measurement": {
          "tolerance": 0.005
        },
        "params": {
          "min": 0.99,
          "max": 1.01
        }
      },
      "face_count": {
        "enabled": true,
        "severity": "error",
        "official": {
          "min": 1,
          "max": 1,
          "unit": "count",
          "statement": "The photo must show the applicant only; no other person may appear in the frame."
        },
        "params": {
          "min": 1,
          "max": 1
        }
      },
      "face_position": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Center your head within the frame."
        },
        "measurement": {
          "tolerance": 0.01,
          "uncertainBelowConfidence": 0.3
        },
        "policy": {
          "max": 0.06,
          "onViolation": "warning",
          "reason": "Официальное требование сформулировано качественно («по центру кадра»); числовой допуск — наша политика, поэтому нарушение остаётся предупреждением."
        },
        "params": {
          "maxHorizontalOffset": 0.06,
          "maxVerticalOffset": 0.12,
          "checkVertical": false
        }
      },
      "head_size": {
        "enabled": true,
        "severity": "error",
        "official": {
          "min": 0.5,
          "max": 0.69,
          "unit": "ratio",
          "reference": "image_height",
          "statement": "Top of the head (including hair) to the bottom of the chin: between 50 % and 69 % of the total image height."
        },
        "measurement": {
          "tolerance": 0.01,
          "uncertainBelowConfidence": 0.45
        },
        "params": {
          "reference": "image_height"
        }
      },
      "eye_line": {
        "enabled": true,
        "severity": "error",
        "official": {
          "min": 0.56,
          "max": 0.69,
          "unit": "ratio",
          "reference": "bottom",
          "statement": "Eye height measured from the bottom of the image: between 56 % and 69 % of the image height."
        },
        "measurement": {
          "tolerance": 0.01,
          "uncertainBelowConfidence": 0.35
        },
        "params": {
          "reference": "bottom"
        }
      },
      "face_pose": {
        "enabled": true,
        "severity": "error",
        "official": {
          "statement": "Face the camera directly; the head must not be tilted or turned, with a neutral expression."
        },
        "measurement": {
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "error",
          "reason": "Углы (roll 3°, yaw 5°, pitch 5°) — пороги алгоритма: официальное требование качественное, но сильное отклонение от анфаса означает несоответствие."
        },
        "params": {
          "maxRoll": 3,
          "maxYaw": 5,
          "maxPitch": 5,
          "uncertainBelowConfidence": 0.5
        }
      },
      "head_coverage": {
        "enabled": true,
        "severity": "error",
        "official": {
          "statement": "The photo must show the entire head, from the top of the hair to the bottom of the chin."
        },
        "measurement": {
          "tolerance": 0
        },
        "policy": {
          "min": 0.004,
          "onViolation": "error",
          "reason": "Минимальный запас до края кадра — технический порог алгоритма."
        },
        "params": {
          "minMargin": 0.004
        }
      },
      "eye_open": {
        "enabled": true,
        "severity": "error",
        "official": {
          "statement": "Make sure your eyes are open and you look straight into the camera."
        },
        "measurement": {
          "uncertainBelowConfidence": 0.25
        },
        "policy": {
          "min": 0.17,
          "onViolation": "error",
          "reason": "Порог раскрытости глаз (eyelid aspect ratio) — величина алгоритма."
        },
        "params": {
          "minEyeAspectRatio": 0.17,
          "blinkThreshold": 0.5
        }
      },
      "glasses": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Starting November 1, 2016, eye glasses are no longer allowed in visa photos."
        },
        "measurement": {
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Классификатора очков в модели нет: проверка только указывает на возможные препятствия в области глаз и никогда не утверждает их наличие. Поэтому статус не может быть отказом."
        },
        "params": {
          "maxGlareRatio": 0.035,
          "maxRimRun": 0.35
        }
      },
      "sharpness": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "The image must be in focus and sharp; a blurred photo will be rejected."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.6
        },
        "policy": {
          "min": 0.2,
          "onViolation": "error",
          "reason": "Порог ROI-оценки резкости 0…1 — величина алгоритма: официального числа в документе нет. Нарушением считается только уверенный провал оценки (ниже 0.20), а нехватка данных даёт «требует проверки»."
        },
        "params": {
          "minSharpnessScore": 0.35,
          "warnSharpnessScore": 0.2,
          "minLaplacianVariance": 110,
          "minTenengrad": 60
        }
      },
      "exposure": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Sit so that your face is fully lit: no underexposure, no blown highlights, no shadows across the face."
        },
        "measurement": {
          "tolerance": 0
        },
        "policy": {
          "onViolation": "error",
          "reason": "Диапазоны яркости и лимиты клиппинга — параметры алгоритма; сильное отклонение считается несоответствием требованию «лицо полностью освещено»."
        },
        "params": {
          "minMean": 60,
          "maxMean": 205,
          "severeLow": 42,
          "severeHigh": 232,
          "maxClippedHighlights": 0.02,
          "maxClippedShadows": 0.05
        }
      },
      "lighting": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "There must be no distracting shadows across your face or in the background."
        },
        "measurement": {
          "tolerance": 0
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Разница яркости сторон лица — эвристика алгоритма."
        },
        "params": {
          "maxSideDifference": 38,
          "maxBacklightDifference": 110
        }
      },
      "background": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "The background must be plain white or off-white, uncluttered, without shadows or objects."
        },
        "measurement": {
          "tolerance": 0
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Пороги однородности, теней и цветового отклонения — метрики алгоритма."
        },
        "params": {
          "minUniformity": 0.75,
          "maxShadowScore": 0.35,
          "maxClutterScore": 0.3,
          "maxColorCastScore": 0.3,
          "maxTargetDeviation": 0.22,
          "targetColor": "#FFFFFF"
        }
      },
      "noise": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "The photo must be clear, without visible grain."
        },
        "measurement": {
          "tolerance": 0
        },
        "policy": {
          "max": 7,
          "onViolation": "warning",
          "reason": "Оценка шума (σ) — метрика алгоритма."
        },
        "params": {
          "maxSigma": 7
        }
      },
      "compression_artifacts": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Compression artefacts must not distort facial features."
        },
        "measurement": {
          "tolerance": 0
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Блочность и «звон» — эвристики алгоритма."
        },
        "params": {
          "maxBlockiness": 0.14,
          "maxRinging": 0.4
        }
      },
      "expression": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "A neutral facial expression with both eyes open and mouth closed is required.",
          "reference": "expression"
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Оценка улыбки и открытого рта — эвристика сервиса; официальное требование качественное, поэтому результат остаётся предупреждением, а не отказом."
        },
        "params": {
          "maxSmileScore": 0.35,
          "maxJawOpen": 0.3,
          "uncertainBelowConfidence": 0.5
        }
      },
      "mouth": {
        "enabled": true,
        "severity": "error",
        "official": {
          "statement": "Mouth must be closed (neutral expression).",
          "reference": "mouth"
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Порог раскрытия рта — измеряемая величина; при низкой уверенности проверка возвращает «требует проверки», а не отказ."
        },
        "params": {
          "maxLipGap": 0.035,
          "maxMouthOpenRatio": 0.35,
          "uncertainBelowConfidence": 0.6
        }
      },
      "headwear": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Head coverings are not permitted, except for religious or medical reasons (a signed statement may be required)."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "CV определяет только «возможно обнаружен головной убор»; допустимость религиозного или медицинского головного убора решает документ, поэтому запрет не выносится автоматически."
        },
        "params": {
          "minCoverage": 0.3,
          "uncertainBelowConfidence": 0.55,
          "allowed": "religious_or_medical"
        }
      },
      "hair_occlusion": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Hair must not cover the eyes or obscure the face."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Перекрытие оценивается эвристикой по ROI; уверенное перекрытие показывается предупреждением, чтобы не давать ложных отказов."
        },
        "params": {
          "minOcclusionArea": 0.25,
          "uncertainBelowConfidence": 0.55
        }
      },
      "face_obstruction": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "The face must be unobstructed: no hands, masks, headphones, microphones or other objects."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Классификация посторонних объектов — эвристика; результат не может быть отказом без высокой уверенности."
        },
        "params": {
          "maxCoveredRatio": 0.18,
          "uncertainBelowConfidence": 0.6
        }
      },
      "red_eye": {
        "enabled": true,
        "severity": "warning",
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Red-eye — артефакт вспышки; документ не задаёт числового порога, поэтому это предупреждение сервиса."
        },
        "params": {
          "minRedDominance": 40,
          "minRedPixelRatio": 0.06,
          "uncertainBelowConfidence": 0.5
        }
      },
      "highlight": {
        "enabled": true,
        "severity": "warning",
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Доля выбитых участков на коже — метрика алгоритма; белый фон документа пересветом не считается."
        },
        "params": {
          "maxSkinHighlightRatio": 0.12,
          "warnSkinHighlightRatio": 0.06,
          "nearWhiteLuma": 248,
          "uncertainBelowConfidence": 0.5
        }
      },
      "lighting_balance": {
        "enabled": true,
        "severity": "warning",
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Числовая разница яркости левой и правой половины лица — политика сервиса; официальное требование сформулировано качественно («ровное освещение»)."
        },
        "params": {
          "maxLumaDifference": 28,
          "maxLumaDifferencePercent": 0.18,
          "maxVerticalGradient": 30,
          "uncertainBelowConfidence": 0.5
        }
      },
      "shadow_face": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "The photo must be evenly lit: no shadows on the face."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Площадь и контраст локальной тени — метрики алгоритма, проверяющие качественное требование."
        },
        "params": {
          "minSideDifference": 26,
          "maxShadowArea": 0.12,
          "uncertainBelowConfidence": 0.5
        }
      },
      "shadow_background": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Plain white or off-white background, without shadows."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Тень на фоне измеряется по ячейкам; результат показывается с областью на изображении."
        },
        "params": {
          "maxShadowScore": 0.35,
          "maxShadowArea": 0.05,
          "uncertainBelowConfidence": 0.5
        }
      },
      "background_quality": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "The background must be plain white or off-white, uniform and without gradients."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Пороги однородности, градиента и светлоты фона — метрики алгоритма. Посторонние объекты проверяет отдельная проверка background."
        },
        "params": {
          "minUniformity": 0.75,
          "maxGradient": 0.12,
          "minMeanLuma": 195,
          "maxTargetDeviation": 0.25,
          "maxHaloRatio": 0.1,
          "uncertainBelowConfidence": 0.5
        }
      },
      "retouching": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "The photo must not be digitally enhanced or altered to change your appearance (no retouching, no beauty filters)."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Ансамбль сигналов (текстура кожи, сглаживание, следы пересохранения) даёт предупреждение, а не доказательство редактирования."
        },
        "params": {
          "uncertainBelowConfidence": 0.45,
          "warnRisk": 0.45
        }
      },
      "ai_manipulation": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "AI-edited or AI-generated photos are not accepted; submitted photos are checked for AI use."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Ensemble из независимых сигналов; один сигнал (метаданные, пересохранение) никогда не является достаточным. Автоматическая проверка может ошибаться и не доказывает способ создания фотографии."
        },
        "params": {
          "uncertainBelowConfidence": 0.45,
          "warnRisk": 0.5
        }
      },
      "background_replacement": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Digital alteration of the photo (including a replaced or generated background) is not accepted."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Граница «субъект/фон», несовпадение шума и текстуры — эвристики; результат остаётся предупреждением."
        },
        "params": {
          "uncertainBelowConfidence": 0.45,
          "warnRisk": 0.5
        }
      },
      "color_profile": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "The image must be a 24-bit colour image in sRGB colour space."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Отсутствие ICC-профиля не является отказом; проверка сообщает, что цветовое пространство не подтверждено."
        },
        "params": {
          "requireSrgb": true,
          "allowedSpaces": [
            "sRGB",
            "RGB"
          ]
        }
      },
      "dpi": {
        "enabled": false,
        "measurement": {
          "tolerance": 0
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Официальные цифровые требования США задают пиксельные размеры (600–1200 px), а не DPI. Проверка DPI оставлена в профиле выключенной: включите её, если документ действительно требует конкретный DPI."
        },
        "params": {
          "requiredDpi": 300,
          "tolerance": 25,
          "warnTolerance": 60
        }
      }
    },
    "visual": {
      "showCenterLine": true,
      "showEyeLine": true,
      "showHeadZone": true,
      "headZoneOpacity": 0.16,
      "labels": {
        "eyeLine": "Линия глаз",
        "headZoneTop": "Верхняя граница головы",
        "headZoneBottom": "Нижняя граница головы (подбородок)",
        "centerLine": "Центр кадра"
      }
    },
    "cta": {
      "url": "https://gostfoto.ru/foto-na-vizu",
      "label": "Сделать новое фото",
      "productUrl": "https://gostfoto.ru/start",
      "helperText": "Сделаем фото по требованиям DS-160 и подготовим файл нужного размера."
    },
    "seo": {
      "slug": "viza-ssha",
      "aliases": [
        "ds160",
        "ds-160",
        "visa-usa",
        "us-visa"
      ],
      "title": "Проверка фото на визу США (DS-160) — бесплатный валидатор",
      "description": "Бесплатная проверка фотографии для визы США: квадрат 600–1200 px, высота головы 50–69 %, положение глаз 56–69 %, белый фон, JPEG до 240 КБ. Разметка прямо на вашем фото.",
      "h1": "Проверка фотографии для визы США (DS-160)",
      "canonical": "https://gostfoto.ru/validator/viza-ssha",
      "keywords": [
        "проверка фото на визу сша",
        "ds-160 фото требования",
        "фото 600x600",
        "проверить фото на визу",
        "виза сша фото валидатор"
      ],
      "intro": "Загрузите фотографию — валидатор определит лицо, измерит высоту головы и положение линии глаз, проверит фон, резкость и экспозицию и покажет результат прямо на снимке. Фотография обрабатывается в вашем браузере и не отправляется на сервер.",
      "requirements": [
        "Размер: квадрат от 600×600 до 1200×1200 пикселей (2×2 дюйма, 50×50 мм).",
        "Формат: JPEG (24 бита, sRGB); загрузка в DS-160 — до 240 КБ.",
        "Высота головы от макушки (с волосами) до подбородка: 50–69 % высоты изображения.",
        "Положение глаз: 56–69 % высоты изображения, считая от нижнего края.",
        "Голова по центру кадра, лицо анфас, глаза открыты, выражение нейтральное.",
        "Фон однородный белый или почти белый, без теней и посторонних предметов.",
        "Очки не допускаются (с 1 ноября 2016 года).",
        "Фотография сделана не позднее шести месяцев до подачи заявления."
      ],
      "faq": [
        {
          "question": "Какой размер фотографии нужен для DS-160?",
          "answer": "Квадратное изображение от 600×600 до 1200×1200 пикселей в формате JPEG весом до 240 КБ. Печатный размер — 2×2 дюйма (50×50 мм)."
        },
        {
          "question": "Какой высоты должна быть голова на фото для визы США?",
          "answer": "От 50 % до 69 % высоты изображения — это официальное значение Photo Composition Template Государственного департамента, валидатор проверяет именно его."
        },
        {
          "question": "Где должны находиться глаза на фотографии?",
          "answer": "56–69 % высоты изображения от нижнего края — официальное требование Photo Composition Template. Валидатор измеряет положение глаз и показывает допустимую зону прямо на фото."
        },
        {
          "question": "Можно ли фотографироваться в очках?",
          "answer": "Нет. С 1 ноября 2016 года очки на визовых фотографиях не допускаются. Валидатор предупредит, если заметит признаки оправы или блики на уровне глаз, но не утверждает их наличие: классификатора очков в модели нет."
        },
        {
          "question": "Отправляется ли моя фотография на сервер?",
          "answer": "Нет. Лицо, геометрия и качество анализируются локально в браузере. Серверный анализ используется только если вы сами нажмёте кнопку дополнительной проверки."
        },
        {
          "question": "Гарантирует ли проверка, что консульство примет фото?",
          "answer": "Нет. Валидатор показывает соответствие опубликованным требованиям; окончательное решение принимает консульский отдел."
        }
      ]
    }
  },
  {
    "id": "ru-zagran-gosuslugi",
    "schemaVersion": "1.0",
    "name": "Загранпаспорт РФ (электронная подача через Госуслуги)",
    "shortName": "Загранпаспорт / Госуслуги",
    "country": "RU",
    "authority": "МВД России, портал Госуслуг",
    "sourceUrl": "https://35.мвд.рф/news/item/61940166/",
    "sourceUrls": [
      "https://35.мвд.рф/news/item/61940166/",
      "https://www.gosuslugi.ru/help/faq/zagranpassport",
      "http://publication.pravo.gov.ru/"
    ],
    "sourceCheckedAt": "2026-09-15",
    "provenance": {
      "sourceName": "Административный регламент МВД России (приказ МВД России от 31.03.2021 № 186), пункт 89 — требования к фотографиям",
      "sourceUrl": "https://35.мвд.рф/news/item/61940166/",
      "checkedAt": "2026-09-15",
      "requirementsVersion": "приказ МВД России от 31.03.2021 № 186, п. 89 (редакция, опубликованная на официальном сайте МВД России, проверена 2026-09-15)",
      "secondarySources": [
        {
          "name": "Официальный интернет-портал правовой информации (полный текст приказа)",
          "url": "http://publication.pravo.gov.ru/"
        },
        {
          "name": "Госуслуги — справка по услуге «Загранпаспорт»",
          "url": "https://www.gosuslugi.ru/help/faq/zagranpassport"
        }
      ],
      "status": "verified",
      "note": "Формулировки п. 89 подтверждены на официальном сайте МВД России (35.мвд.рф), где пункт приведён дословно: размер 35×45 мм, расстояние от макушки до подбородка не более 80 % высоты кадра, фон белый и ровный без теней и посторонних предметов, строго анфас, глаза открыты, без ретуши, очки допускаются без тонированных стёкол, если оправа не закрывает глаза. Полный текст приказа рекомендуется дополнительно сверить на publication.pravo.gov.ru перед публичным запуском. Числовые пороги, которых нет в документе (минимальный размер головы, допуски позиционирования, пороги качества), помечены как policy и не выдаются за официальные требования."
    },
    "verificationNote": "Официально документ задаёт только МАКСИМУМ высоты головы — не более 80 % высоты кадра (п. 89.2). Минимум 70 % — это наша внутренняя политика для читаемости лица (policy, только предупреждение). Пиксельные границы 413×531 px — пересчёт официального размера 35×45 мм при 300 dpi. Положение глаз документом не нормируется: диапазон 42–62 % — ориентир сервиса (policy).",
    "disclaimer": "Проверка выполняется по опубликованным требованиям выбранного документа. Автоматическая проверка не гарантирует принятие фотографии государственным органом или визовым центром. Итоговое решение принимает подразделение по вопросам миграции МВД России.",
    "aliases": [
      "gosuslugi",
      "zagranpasport",
      "zagranpasport-gosuslugi",
      "ru-passport",
      "gosuslugi-zagranpasport"
    ],
    "tags": [
      "passport",
      "ru",
      "35x45mm",
      "verified"
    ],
    "image": {
      "minWidth": 413,
      "maxWidth": 2400,
      "minHeight": 531,
      "maxHeight": 3086,
      "aspectRatio": {
        "min": 0.74,
        "max": 0.82
      },
      "requiredAspectRatio": {
        "width": 35,
        "height": 45
      },
      "aspectRatioNote": "Официально: 35×45 мм (соотношение сторон 35:45 ≈ 0,778).",
      "maxFileSize": 5242880,
      "warnBelowBytes": 10240,
      "formats": [
        "jpeg",
        "png"
      ],
      "digital": {
        "minWidth": 413,
        "minHeight": 531,
        "maxWidth": 2400,
        "maxHeight": 3086,
        "dpi": 300,
        "source": "Пиксельные границы — пересчёт 35×45 мм при 300 dpi (решение сервиса), а не отдельное требование документа."
      },
      "colorSpace": "sRGB",
      "dpi": 300,
      "notes": [
        "Официальный размер фотографии: 35×45 мм (п. 89.1), цветная или чёрно-белая, без головного убора (кроме религиозных случаев, п. 89.1, 89.3).",
        "При 300 dpi 35×45 мм — это примерно 413×531 пиксель (внутренний пересчёт сервиса).",
        "Электронная подача: JPEG (рекомендуется) или PNG, вес файла до 5 МБ.",
        "Официального минимума размера файла нет; 10 КБ — внутренний порог качества (policy).",
        "Фон белый, ровный, без полос, пятен, посторонних предметов и теней (п. 89.8).",
        "Ретушь и художественная обработка запрещены (п. 89.5); форменная одежда, верхняя одежда и шарфы, закрывающие подбородок, не допускаются (п. 89.4)."
      ],
      "nominalPhotoSize": {
        "widthMm": 35,
        "heightMm": 45
      }
    },
    "rules": {
      "file_format": {
        "enabled": true,
        "severity": "error",
        "official": {
          "statement": "Электронная форма подачи принимает JPEG или PNG; печатная фотография может быть цветной или чёрно-белой (п. 89.1)."
        },
        "params": {
          "formats": [
            "jpeg",
            "png"
          ]
        }
      },
      "file_size": {
        "enabled": true,
        "severity": "error",
        "official": {
          "max": 5242880,
          "unit": "bytes",
          "statement": "Форма электронной подачи принимает файл размером до 5 МБ."
        },
        "measurement": {
          "tolerance": 0
        },
        "policy": {
          "min": 10240,
          "onViolation": "warning",
          "reason": "Внутренний порог качества: очень маленький файл обычно означает сильную компрессию. Официального минимума размера файла нет."
        },
        "params": {
          "maxBytes": 5242880,
          "warnBelowBytes": 10240
        }
      },
      "image_size": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "min": 413,
          "max": 2400,
          "unit": "px",
          "statement": "Официальный размер 35×45 мм; при 300 dpi это минимум 413×531 px. Верхняя граница 2400 px — техническое ограничение сервиса."
        },
        "measurement": {
          "tolerance": 0
        },
        "policy": {
          "min": 413,
          "onViolation": "warning",
          "reason": "Пиксельные границы получены пересчётом официального размера 35×45 мм при 300 dpi, а не опубликованы как требование."
        },
        "params": {
          "minWidth": 413,
          "maxWidth": 2400,
          "minHeight": 531,
          "maxHeight": 3086
        }
      },
      "aspect_ratio": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "min": 0.7778,
          "max": 0.7778,
          "unit": "ratio",
          "statement": "Пропорции фотографии 35×45 мм (отношение сторон 0,778)."
        },
        "measurement": {
          "tolerance": 0.043
        },
        "params": {
          "min": 0.74,
          "max": 0.82
        }
      },
      "face_count": {
        "enabled": true,
        "severity": "error",
        "official": {
          "min": 1,
          "max": 1,
          "unit": "count",
          "statement": "На фотографии изображается только заявитель (п. 89.2: голова и верхняя часть плеч гражданина)."
        },
        "params": {
          "min": 1,
          "max": 1
        }
      },
      "face_position": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Документ не требует явного центрирования: важно, чтобы голова и верхняя часть плеч помещались в кадре (п. 89.2)."
        },
        "measurement": {
          "tolerance": 0.01,
          "uncertainBelowConfidence": 0.3
        },
        "policy": {
          "max": 0.07,
          "onViolation": "warning",
          "reason": "Числовой допуск смещения от центра — политика сервиса, а не требование документа."
        },
        "params": {
          "maxHorizontalOffset": 0.07,
          "maxVerticalOffset": 0.14,
          "checkVertical": false
        }
      },
      "head_size": {
        "enabled": true,
        "severity": "error",
        "official": {
          "max": 0.8,
          "unit": "ratio",
          "reference": "image_height",
          "statement": "Расстояние от макушки до подбородка не должно быть более 80 % размера всего изображения по вертикали (п. 89.2)."
        },
        "measurement": {
          "tolerance": 0.01,
          "uncertainBelowConfidence": 0.45
        },
        "policy": {
          "min": 0.7,
          "onViolation": "warning",
          "reason": "Документ задаёт только максимум. Минимум 70 % добавлен сервисом для читаемости лица и не является официальным требованием."
        },
        "params": {
          "reference": "image_height"
        }
      },
      "eye_line": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Положение глаз по высоте кадра документом не нормируется; требуется, чтобы глаза были открыты и волосы их не заслоняли (п. 89.8)."
        },
        "measurement": {
          "tolerance": 0.01,
          "uncertainBelowConfidence": 0.35
        },
        "policy": {
          "min": 0.42,
          "max": 0.62,
          "onViolation": "warning",
          "reason": "Диапазон положения глаз — ориентир сервиса для типовой композиции 35×45 мм."
        },
        "params": {
          "reference": "bottom"
        }
      },
      "face_pose": {
        "enabled": true,
        "severity": "error",
        "official": {
          "statement": "Человек изображается строго анфас, смотрит прямо, с нейтральным выражением и закрытым ртом (п. 89.8)."
        },
        "measurement": {
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "error",
          "reason": "Углы (roll 5°, yaw 8°, pitch 8°) — пороги алгоритма: официальное требование качественное, но заметное отклонение от анфаса означает несоответствие."
        },
        "params": {
          "maxRoll": 5,
          "maxYaw": 8,
          "maxPitch": 8,
          "uncertainBelowConfidence": 0.5
        }
      },
      "head_coverage": {
        "enabled": true,
        "severity": "error",
        "official": {
          "statement": "На фотографии должны помещаться голова и верхняя часть плеч гражданина (п. 89.2)."
        },
        "measurement": {
          "tolerance": 0
        },
        "policy": {
          "min": 0.004,
          "onViolation": "error",
          "reason": "Минимальный запас до края кадра — технический порог алгоритма."
        },
        "params": {
          "minMargin": 0.004
        }
      },
      "eye_open": {
        "enabled": true,
        "severity": "error",
        "official": {
          "statement": "Глаза гражданина должны быть открытыми, а волосы не должны заслонять их (п. 89.8)."
        },
        "measurement": {
          "uncertainBelowConfidence": 0.25
        },
        "policy": {
          "min": 0.17,
          "onViolation": "error",
          "reason": "Порог раскрытости глаз (eyelid aspect ratio) — величина алгоритма."
        },
        "params": {
          "minEyeAspectRatio": 0.17,
          "blinkThreshold": 0.5
        }
      },
      "glasses": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Для граждан, постоянно носящих очки, обязательно фотографирование в очках без тонированных стёкол; оправа не должна закрывать глаза (п. 89.6). Линзы, изменяющие натуральный цвет глаз, не допускаются (п. 89.7)."
        },
        "measurement": {
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Классификатора очков в модели нет: проверка указывает на возможные препятствия в области глаз и не утверждает их наличие."
        },
        "params": {
          "maxGlareRatio": 0.04,
          "maxRimRun": 0.4
        }
      },
      "sharpness": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "На изображении должны достоверно отображаться все особенности лица; редактирование и художественная обработка не допускаются (п. 89.5)."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.6
        },
        "policy": {
          "min": 0.2,
          "onViolation": "error",
          "reason": "Порог ROI-оценки резкости 0…1 — величина алгоритма: официального числа в документе нет. Нарушением считается только уверенный провал оценки (ниже 0.20), а нехватка данных даёт «требует проверки»."
        },
        "params": {
          "minSharpnessScore": 0.33,
          "warnSharpnessScore": 0.2,
          "minLaplacianVariance": 90,
          "minTenengrad": 50
        }
      },
      "exposure": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Изображение должно достоверно отображать особенности лица, без потери деталей (п. 89.5). Фон должен быть ровным, без теней (п. 89.8)."
        },
        "measurement": {
          "tolerance": 0
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Диапазоны яркости и лимиты клиппинга — параметры алгоритма."
        },
        "params": {
          "minMean": 55,
          "maxMean": 210,
          "severeLow": 40,
          "severeHigh": 235,
          "maxClippedHighlights": 0.03,
          "maxClippedShadows": 0.06
        }
      },
      "lighting": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Фон должен быть ровным, без теней; лицо не должно быть затемнено (п. 89.8, 89.5)."
        },
        "measurement": {
          "tolerance": 0
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Разница яркости сторон лица — эвристика алгоритма."
        },
        "params": {
          "maxSideDifference": 42,
          "maxBacklightDifference": 115
        }
      },
      "background": {
        "enabled": true,
        "severity": "error",
        "official": {
          "statement": "Фон должен быть белым, ровным, без полос, пятен и изображения посторонних предметов и теней (п. 89.8)."
        },
        "measurement": {
          "tolerance": 0
        },
        "policy": {
          "onViolation": "error",
          "reason": "Пороги однородности, теней и цветового отклонения — метрики алгоритма, которые проверяют качественное официальное требование к фону."
        },
        "params": {
          "minUniformity": 0.7,
          "maxShadowScore": 0.4,
          "maxClutterScore": 0.35,
          "maxColorCastScore": 0.35,
          "maxTargetDeviation": 0.3,
          "targetColor": "#FFFFFF"
        }
      },
      "noise": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Изображение должно достоверно отображать особенности лица (п. 89.5)."
        },
        "measurement": {
          "tolerance": 0
        },
        "policy": {
          "max": 8,
          "onViolation": "warning",
          "reason": "Оценка шума (σ) — метрика алгоритма."
        },
        "params": {
          "maxSigma": 8
        }
      },
      "compression_artifacts": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Изображение должно достоверно отображать особенности лица без искажений (п. 89.5)."
        },
        "measurement": {
          "tolerance": 0
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Блочность и «звон» — эвристики алгоритма."
        },
        "params": {
          "maxBlockiness": 0.18,
          "maxRinging": 0.45
        }
      },
      "expression": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Лицо должно быть изображено анфас, в нейтральном выражении, без улыбки (п. 89.5 приказа МВД № 186 — изложение)."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Оценка улыбки и открытого рта — эвристика сервиса; требование качественное, поэтому результат остаётся предупреждением."
        },
        "params": {
          "maxSmileScore": 0.35,
          "maxJawOpen": 0.3,
          "uncertainBelowConfidence": 0.5
        }
      },
      "mouth": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Рот должен быть закрыт (нейтральное выражение, п. 89.5 — изложение)."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Порог раскрытия рта — измеряемая величина; при низкой уверенности возвращается «требует проверки», а не отказ."
        },
        "params": {
          "maxLipGap": 0.035,
          "maxMouthOpenRatio": 0.35,
          "uncertainBelowConfidence": 0.6
        }
      },
      "headwear": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Головной убор допускается, если гражданин не может снять его по религиозным убеждениям и убор не скрывает овал лица (п. 89.6 — изложение)."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "CV сообщает только «возможно обнаружен головной убор»; допустимость религиозного головного убора определяет документ, автоматический запрет не выносится."
        },
        "params": {
          "minCoverage": 0.3,
          "uncertainBelowConfidence": 0.55,
          "allowed": "religious_or_medical"
        }
      },
      "hair_occlusion": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Волосы не должны закрывать глаза и скрывать особенности лица (п. 89.5 — изложение)."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Перекрытие оценивается эвристикой по ROI; уверенное перекрытие показывается предупреждением."
        },
        "params": {
          "minOcclusionArea": 0.25,
          "uncertainBelowConfidence": 0.55
        }
      },
      "face_obstruction": {
        "enabled": true,
        "severity": "warning",
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Посторонние предметы перед лицом определяются эвристикой; результат — предупреждение, а не отказ."
        },
        "params": {
          "maxCoveredRatio": 0.18,
          "uncertainBelowConfidence": 0.6
        }
      },
      "red_eye": {
        "enabled": true,
        "severity": "warning",
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Red-eye — артефакт вспышки; документ не задаёт числового порога."
        },
        "params": {
          "minRedDominance": 40,
          "minRedPixelRatio": 0.06,
          "uncertainBelowConfidence": 0.5
        }
      },
      "highlight": {
        "enabled": true,
        "severity": "warning",
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Доля выбитых участков на коже — метрика алгоритма; белый фон пересветом не считается."
        },
        "params": {
          "maxSkinHighlightRatio": 0.12,
          "warnSkinHighlightRatio": 0.06,
          "nearWhiteLuma": 248,
          "uncertainBelowConfidence": 0.5
        }
      },
      "lighting_balance": {
        "enabled": true,
        "severity": "warning",
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Числовая разница яркости половин лица — политика сервиса."
        },
        "params": {
          "maxLumaDifference": 30,
          "maxLumaDifferencePercent": 0.2,
          "maxVerticalGradient": 32,
          "uncertainBelowConfidence": 0.5
        }
      },
      "shadow_face": {
        "enabled": true,
        "severity": "warning",
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Площадь и контраст локальной тени на лице — метрики алгоритма."
        },
        "params": {
          "minSideDifference": 28,
          "maxShadowArea": 0.14,
          "uncertainBelowConfidence": 0.5
        }
      },
      "shadow_background": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Фон должен быть белым, ровным, без полос, пятен и посторонних предметов и теней (п. 89.8)."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Тень на фоне измеряется по ячейкам и показывается областью на изображении."
        },
        "params": {
          "maxShadowScore": 0.4,
          "maxShadowArea": 0.06,
          "uncertainBelowConfidence": 0.5
        }
      },
      "background_quality": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Фон должен быть белым и ровным (п. 89.8 — изложение)."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Пороги однородности и градиента — метрики алгоритма; посторонние объекты проверяет отдельная проверка background."
        },
        "params": {
          "minUniformity": 0.7,
          "maxGradient": 0.14,
          "minMeanLuma": 190,
          "maxTargetDeviation": 0.28,
          "maxHaloRatio": 0.12,
          "uncertainBelowConfidence": 0.5
        }
      },
      "retouching": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "На изображении должны достоверно отображаться все особенности лица; редактирование и художественная обработка не допускаются (п. 89.5)."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Ансамбль сигналов даёт предупреждение, а не доказательство редактирования."
        },
        "params": {
          "uncertainBelowConfidence": 0.45,
          "warnRisk": 0.45
        }
      },
      "ai_manipulation": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Редактирование и художественная обработка фотографии не допускаются (п. 89.5)."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Ensemble из независимых сигналов; один сигнал не является достаточным. Автоматическая проверка может ошибаться."
        },
        "params": {
          "uncertainBelowConfidence": 0.45,
          "warnRisk": 0.5
        }
      },
      "background_replacement": {
        "enabled": true,
        "severity": "warning",
        "official": {
          "statement": "Фон должен быть белым и ровным, без признаков искусственной замены (п. 89.8 — изложение)."
        },
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        },
        "policy": {
          "onViolation": "warning",
          "reason": "Граница «субъект/фон», несовпадение шума и текстуры — эвристики; результат остаётся предупреждением."
        },
        "params": {
          "uncertainBelowConfidence": 0.45,
          "warnRisk": 0.5
        }
      },
      "color_profile": {
        "enabled": false,
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        }
      },
      "dpi": {
        "enabled": false,
        "measurement": {
          "tolerance": 0,
          "uncertainBelowConfidence": 0.5
        }
      }
    },
    "visual": {
      "showCenterLine": true,
      "showEyeLine": true,
      "showHeadZone": true,
      "headZoneOpacity": 0.16,
      "labels": {
        "eyeLine": "Линия глаз",
        "headZoneTop": "Верхняя граница головы",
        "headZoneBottom": "Нижняя граница головы",
        "centerLine": "Центр кадра"
      }
    },
    "cta": {
      "url": "https://gostfoto.ru/foto-na-zagranpasport",
      "label": "Сделать новое фото",
      "productUrl": "https://gostfoto.ru/start",
      "helperText": "Подготовим фото 35×45 мм по требованиям МВД и сохраним файл нужного размера."
    },
    "seo": {
      "slug": "gosuslugi",
      "aliases": [
        "zagranpasport",
        "zagranpasport-gosuslugi",
        "gosuslugi-zagranpasport"
      ],
      "title": "Проверка фото на загранпаспорт через Госуслуги — бесплатный валидатор",
      "description": "Бесплатная проверка фотографии 35×45 мм для загранпаспорта: пропорции, голова не более 80 % высоты кадра, белый фон без теней, глаза открыты, без ретуши. Разметка прямо на вашем фото.",
      "h1": "Проверка фотографии на загранпаспорт (Госуслуги)",
      "canonical": "https://gostfoto.ru/validator/gosuslugi",
      "keywords": [
        "проверка фото на загранпаспорт",
        "фото 35x45 госуслуги",
        "требования к фото загранпаспорт",
        "проверить фото госуслуги",
        "фото на загранпаспорт онлайн"
      ],
      "intro": "Загрузите фотографию — валидатор проверит пропорции 35×45, измерит высоту головы и положение глаз, оценит фон, резкость и освещение и покажет замечания прямо на снимке. Обработка происходит в браузере.",
      "requirements": [
        "Размер 35×45 мм (при 300 dpi примерно 413×531 пиксель), цветная или чёрно-белая (п. 89.1).",
        "Расстояние от макушки до подбородка — не более 80 % высоты кадра (п. 89.2).",
        "На фотографии должны помещаться голова и верхняя часть плеч (п. 89.2).",
        "Строго анфас, смотрит прямо, нейтральное выражение, закрытый рот; глаза открыты, волосы их не заслоняют (п. 89.8).",
        "Фон белый, ровный, без полос, пятен, посторонних предметов и теней (п. 89.8).",
        "Без ретуши и художественной обработки: все особенности лица должны отображаться достоверно (п. 89.5).",
        "Форменная одежда, верхняя одежда и шарфы, закрывающие подбородок, не допускаются (п. 89.4).",
        "Очки допускаются только без тонированных стёкол и так, чтобы оправа не закрывала глаза (п. 89.6); линзы, меняющие цвет глаз, запрещены (п. 89.7)."
      ],
      "faq": [
        {
          "question": "Какого размера должно быть фото на загранпаспорт?",
          "answer": "35×45 мм (п. 89.1 Административного регламента МВД, приказ № 186 от 31.03.2021). При 300 dpi это примерно 413×531 пиксель — валидатор проверяет пропорции и минимальное разрешение."
        },
        {
          "question": "Сколько места должна занимать голова на фото?",
          "answer": "Официальное требование — не более 80 % высоты кадра от макушки до подбородка (п. 89.2). Минимум 70 % — наша внутренняя рекомендация для читаемости лица, а не требование документа."
        },
        {
          "question": "Можно ли фотографироваться в очках?",
          "answer": "Да, если вы носите их постоянно: стёкла должны быть без тонировки, а оправа не должна закрывать глаза (п. 89.6). Линзы, меняющие цвет глаз, запрещены (п. 89.7). Валидатор предупредит, если заметит блики или тёмную линию оправы."
        },
        {
          "question": "Какой фон нужен для фото на загранпаспорт?",
          "answer": "Белый, ровный, без полос, пятен, посторонних предметов и теней (п. 89.8). Валидатор проверяет однородность, тени и цветовой оттенок фона."
        },
        {
          "question": "Можно ли отретушировать фотографию?",
          "answer": "Нет. Ретушь и художественная обработка запрещены: все особенности лица должны отображаться достоверно (п. 89.5). Валидатор не изменяет ни внешность, ни кадр — он только измеряет и объясняет, что не соответствует требованиям."
        },
        {
          "question": "Сохраняется ли моя фотография на сервере?",
          "answer": "Нет. Проверка выполняется в браузере, изображение не отправляется на сервер и не хранится."
        }
      ]
    }
  }
];
